import type { PropsWithChildren } from "react"

import { AppSidebar } from "@/components/app-sidebar"
import { AppSidebarHeader } from "@/components/app-sidebar-header"
import type { BreadcrumbItem } from "@/types"

export default function AppSidebarLayout({
  children,
  breadcrumbs = [],
}: PropsWithChildren<{
  breadcrumbs?: BreadcrumbItem[]
}>) {
  return (
    <div className="bg-background min-h-screen">
      <AppSidebar />
      <div className="flex flex-1 flex-col overflow-hidden pl-24 lg:pl-80">
        <AppSidebarHeader breadcrumbs={breadcrumbs} />
        <div className="flex-1 overflow-auto overflow-x-hidden">
          <div className="container mx-auto p-6">{children}</div>
        </div>
      </div>
    </div>
  )
}
